/**--external-- */
import React from "react";
import PropTypes from "prop-types";
import MarkdownView from "UIComponents/MarkdownView";
import WorksheetTextView from "UIComponents/WorksheetTextView";
import classNames from "classnames";
import { sanitizeLatexText } from "@toddle-edu/common-utils";

const containerStyle = {
  overflow: "visible",
};

const TextViewWrapper = props => {
  const {
    isAiGeneratedField,
    value,
    customTextStyle,
    mode,
    isInactiveQuestionRevamp,
    showDocEditor,
  } = props;
  const contentContainerClass = classNames("text-subtitle-2");

  return isAiGeneratedField ? (
    <MarkdownView
      content={sanitizeLatexText(value)}
      isAiGeneratedField={isAiGeneratedField}
      contentContainerClass={contentContainerClass}
      containerStyle={containerStyle}
      enableHTMLrendering={true}
    />
  ) : (
    <WorksheetTextView
      value={value}
      mode={mode}
      customTextStyle={customTextStyle}
      isRtlAlignmentRequired={true}
      isInactiveQuestionRevamp={isInactiveQuestionRevamp}
      showDocEditor={showDocEditor}
    />
  );
};

export default TextViewWrapper;

TextViewWrapper.propTypes = {
  isAiGeneratedField: PropTypes.bool,
  isInactiveQuestionRevamp: PropTypes.bool,
  showDocEditor: PropTypes.bool,
};

TextViewWrapper.defaultProps = {
  isAiGeneratedField: false,
  isInactiveQuestionRevamp: false,
  showDocEditor: false,
};
